import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, unref as _unref, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = ["onDragenter", "onDragover", "onDragleave", "onDrop"]
const _hoisted_2 = ["href"]
const _hoisted_3 = ["onDragstart"]
const _hoisted_4 = { class: "top" }
const _hoisted_5 = { class: "date" }
const _hoisted_6 = {
  key: 0,
  class: "codes"
}
const _hoisted_7 = { class: "code" }
const _hoisted_8 = { class: "title" }
const _hoisted_9 = { class: "lable" }
const _hoisted_10 = { class: "box-image" }
const _hoisted_11 = ["src", "alt"]
const _hoisted_12 = {
  key: 1,
  class: "placeholder"
}
const _hoisted_13 = ["href"]
const _hoisted_14 = ["onDragstart"]
const _hoisted_15 = { class: "top" }
const _hoisted_16 = { class: "date" }
const _hoisted_17 = { class: "codes" }
const _hoisted_18 = {
  key: 0,
  class: "code"
}
const _hoisted_19 = { class: "code" }
const _hoisted_20 = { class: "title" }
const _hoisted_21 = { class: "lable" }
const _hoisted_22 = { class: "box-image" }
const _hoisted_23 = {
  key: 0,
  class: "approved-item"
}
const _hoisted_24 = ["src", "alt"]
const _hoisted_25 = {
  key: 2,
  class: "placeholder"
}
const _hoisted_26 = ["onDragenter", "onDragover", "onDragleave", "onDrop"]
const _hoisted_27 = {
  key: 0,
  class: "no-item"
}

import { ref, onMounted } from "vue";
import { useStore } from "vuex";
import Axios from "axios";
import Localizer from "@Scripts/Common/Localizer";
import FormHelper from "@Scripts/Common/FormHelper";


export default /*@__PURE__*/_defineComponent({
  __name: 'ProfileFavoriteList',
  props: {
    accentColor: {},
    roles: {}
  },
  setup(__props: any) {

const props = __props;

const store = useStore();
const localizer = Localizer;
const isLoading = ref(false);
const profileFavorites = ref<any[]>([]);
const validationErrors = ref<any[]>([]);
const routes = (window as any).App.routes;

onMounted(async () => {
	await getData();
});

async function getData() {
	isLoading.value = true;
	const result = (await Axios.post(routes.PrivateArea_GetProfileFavoriteListData)).data;
	profileFavorites.value = result.profileFavorites;
	isLoading.value = false;
}

function dragFavoriteStart(e: any, favorite: any) {
	e.dataTransfer.setData("text", JSON.stringify({ profileFavoriteId: favorite.id, profileFavoriteType: favorite.itemType }));
}

function dragFavoriteEnter(e: any, favorite: any) {
	e.target.className = "item dropzone active";
}

function dragFavoriteOver(e: any, favorite: any) {
	e.preventDefault();
}

function dragFavoriteLeave(e: any, favorite: any) {
	e.target.className = "item dropzone";
	e.preventDefault();
}

async function dropOnFavorite(e: any, favorite: any, mode: string) {
	let data = JSON.parse(e.dataTransfer.getData("text"));
	e.preventDefault();
	e.target.className = "item dropzone";

	try {
		await Axios.post(routes.PrivateArea_MoveProfileFavorite, { profileFavoriteId: data.profileFavoriteId, profileFavoriteType: data.profileFavoriteType, targetProfileFavoriteId: favorite.id, targetProfileFavoriteType: favorite.itemType, mode: mode });

	} catch (error) {
		if (error.response && error.response.status === 400) {
			validationErrors.value = FormHelper.getValidationErrors(error.response.data);
		}
		for (const validationError of validationErrors.value) {
			store.dispatch("accountAreaToastStore/onAddToast", { message: validationError.message, type: "Warning" });
		}
	}

	getData();
}

return (_ctx: any,_cache: any) => {
  const _component_app_addprofilefavorite = _resolveComponent("app-addprofilefavorite")!

  return (!isLoading.value)
    ? (_openBlock(), _createElementBlock("div", {
        key: 0,
        class: _normalizeClass(["item-list", [{'data-accentcolor': __props.accentColor}, '']]),
        "data-Favorite": ""
      }, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(profileFavorites.value, (favorite, index) => {
          return (_openBlock(), _createElementBlock(_Fragment, {
            key: 'favorite'+index
          }, [
            _createElementVNode("a", {
              class: "item dropzone",
              onDragenter: ($event: any) => (dragFavoriteEnter($event, favorite.profileFavorite)),
              onDragover: ($event: any) => (dragFavoriteOver($event, favorite.profileFavorite)),
              onDragleave: ($event: any) => (dragFavoriteLeave($event, favorite.profileFavorite)),
              onDrop: ($event: any) => (dropOnFavorite($event, favorite.profileFavorite, 'Up'))
            }, null, 40, _hoisted_1),
            (favorite.profileFavorite.itemType=='Project')
              ? (_openBlock(), _createElementBlock("a", {
                  href: favorite.project.linkUrl,
                  class: "item",
                  "data-type": "project",
                  key: favorite.project.idMaster,
                  draggable: "false"
                }, [
                  _createElementVNode("div", {
                    onDragstart: ($event: any) => (dragFavoriteStart($event, favorite.profileFavorite)),
                    draggable: "true",
                    class: "drag"
                  }, [...(_cache[2] || (_cache[2] = [
                    _createElementVNode("img", {
                      src: "/areas/privatearea/images/drag.svg",
                      class: "image",
                      width: "50",
                      height: "15",
                      alt: "drag"
                    }, null, -1)
                  ]))], 40, _hoisted_3),
                  _createElementVNode("div", _hoisted_4, [
                    _createElementVNode("div", _hoisted_5, [
                      _cache[3] || (_cache[3] = _createElementVNode("span", { class: "icon fastic-folder" }, null, -1)),
                      _createTextVNode(" " + _toDisplayString(_unref(localizer).get("PrivateArea.Common.Project")), 1)
                    ]),
                    (__props.roles.split(',').filter(x=> x=='DREArea_Admin' || x == 'DREArea_Sales') && favorite.project.orderCode)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                          _createElementVNode("span", _hoisted_7, "Ord. " + _toDisplayString(favorite.project.orderCode), 1)
                        ]))
                      : _createCommentVNode("", true),
                    _createVNode(_component_app_addprofilefavorite, {
                      itemIdMaster: favorite.project.idMaster,
                      "item-type": "Project",
                      isFavoritePage: true,
                      onUpdateData: _cache[0] || (_cache[0] = ($event: any) => (getData()))
                    }, null, 8, ["itemIdMaster"])
                  ]),
                  _createElementVNode("div", _hoisted_8, [
                    _createElementVNode("span", _hoisted_9, _toDisplayString(favorite.project.title), 1)
                  ]),
                  _createElementVNode("div", _hoisted_10, [
                    (favorite.project.fileCode)
                      ? (_openBlock(), _createElementBlock("img", {
                          key: 0,
                          loading: "lazy",
                          src: favorite.project.linkImage,
                          width: "405",
                          height: "303",
                          alt: favorite.project.title,
                          draggable: "false"
                        }, null, 8, _hoisted_11))
                      : (_openBlock(), _createElementBlock("div", _hoisted_12, [...(_cache[4] || (_cache[4] = [
                          _createElementVNode("div", { class: "content" }, [
                            _createElementVNode("span", { class: "icon fastic-image" })
                          ], -1)
                        ]))]))
                  ])
                ], 8, _hoisted_2))
              : _createCommentVNode("", true),
            (favorite.profileFavorite.itemType=='Asset')
              ? (_openBlock(), _createElementBlock("a", {
                  href: favorite.asset.linkUrl,
                  class: "item",
                  key: favorite.asset.idMaster,
                  draggable: "false"
                }, [
                  _createElementVNode("div", {
                    onDragstart: ($event: any) => (dragFavoriteStart($event, favorite.profileFavorite)),
                    class: "drag"
                  }, [...(_cache[5] || (_cache[5] = [
                    _createElementVNode("img", {
                      src: "/areas/privatearea/images/drag.svg",
                      class: "image",
                      width: "50",
                      height: "15",
                      alt: "drag"
                    }, null, -1)
                  ]))], 40, _hoisted_14),
                  _createElementVNode("div", _hoisted_15, [
                    _createElementVNode("div", _hoisted_16, _toDisplayString(favorite.asset.dateItem), 1),
                    _createElementVNode("div", _hoisted_17, [
                      (__props.roles.split(',').filter(x=> x=='DREArea_Admin' || x == 'DREArea_Sales') && favorite.asset.projectCode)
                        ? (_openBlock(), _createElementBlock("span", _hoisted_18, "Ord. " + _toDisplayString(favorite.asset.projectCode), 1))
                        : _createCommentVNode("", true),
                      _createElementVNode("span", _hoisted_19, "Cod. " + _toDisplayString(favorite.asset.code), 1)
                    ]),
                    _createVNode(_component_app_addprofilefavorite, {
                      itemIdMaster: favorite.asset.idMaster,
                      "item-type": "Asset",
                      isFavoritePage: true,
                      onUpdateData: _cache[1] || (_cache[1] = ($event: any) => (getData()))
                    }, null, 8, ["itemIdMaster"])
                  ]),
                  _createElementVNode("div", _hoisted_20, [
                    _createElementVNode("span", _hoisted_21, _toDisplayString(favorite.asset.title), 1)
                  ]),
                  _createElementVNode("div", _hoisted_22, [
                    (favorite.asset.isApproved)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_23, [
                          _cache[6] || (_cache[6] = _createElementVNode("span", { class: "icon fastic-check" }, null, -1)),
                          _createTextVNode(_toDisplayString(_unref(localizer).get("PrivateArea.Common.AssetApproved")), 1)
                        ]))
                      : _createCommentVNode("", true),
                    (favorite.asset.fileCode)
                      ? (_openBlock(), _createElementBlock("img", {
                          key: 1,
                          src: favorite.asset.linkImage,
                          loading: "lazy",
                          width: "405",
                          height: "303",
                          alt: favorite.asset.title,
                          draggable: "false"
                        }, null, 8, _hoisted_24))
                      : (_openBlock(), _createElementBlock("div", _hoisted_25, [...(_cache[7] || (_cache[7] = [
                          _createElementVNode("div", { class: "content" }, [
                            _createElementVNode("span", { class: "icon fastic-image" })
                          ], -1)
                        ]))]))
                  ])
                ], 8, _hoisted_13))
              : _createCommentVNode("", true),
            (index === profileFavorites.value.length-1)
              ? (_openBlock(), _createElementBlock("a", {
                  class: "item dropzone",
                  key: index,
                  onDragenter: ($event: any) => (dragFavoriteEnter($event, favorite.profileFavorite)),
                  onDragover: ($event: any) => (dragFavoriteOver($event, favorite.profileFavorite)),
                  onDragleave: ($event: any) => (dragFavoriteLeave($event, favorite.profileFavorite)),
                  onDrop: ($event: any) => (dropOnFavorite($event, favorite.profileFavorite, 'Down'))
                }, null, 40, _hoisted_26))
              : _createCommentVNode("", true)
          ], 64))
        }), 128)),
        (profileFavorites.value.length===0)
          ? (_openBlock(), _createElementBlock("div", _hoisted_27, _toDisplayString(_unref(localizer).get("PrivateArea.Common.Asset_ProfileFavoriteList_NoFavorite")), 1))
          : _createCommentVNode("", true)
      ], 2))
    : _createCommentVNode("", true)
}
}

})